export const headerDialogs = {
    APP_LAUNCHER: "app-launcher",
    BURGER_MENU: "burger-menu",
    HOME: "home",
    USER: "user",
    SETTINGS: "settings",
    NOTIFICATIONS: "notifications",
    HELP: "help"
};
export const headerIcons = {
    APP_LAUNCHER: "uic:appswitcher",
    BURGER_MENU: "uic:burger",
    HOME: "uic:apps",
    USER: "uic:user",
    SETTINGS: "uic:settings",
    NOTIFICATIONS: "uic:notifications",
    HELP: "uic:help"
};
//# sourceMappingURL=constants.js.map
